import { Flex, Image } from '@podiumhq/design-system';

import blueCheck from '../assets/blueCheck.svg';
import { columnStyles } from '../styles';

import BundleFeatureTitle from './BundleFeatureTitle';

const BundleFeatureListItem = ({
  featureItem,
  featureItemHoverLabel,
  ...wrapperProps
}) => (
  <Flex justify="center" textAlign="center" {...columnStyles} {...wrapperProps}>
    {featureItem && typeof featureItem === 'boolean' ? (
      <Image alt="blue check" boxSize="16px" src={blueCheck} />
    ) : featureItem ? (
      <BundleFeatureTitle
        hoverLabel={featureItemHoverLabel}
        title={featureItem}
      />
    ) : null}
  </Flex>
);

export default BundleFeatureListItem;
